import { Autocomplete, Box, Popper, TextField, Typography } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { PlatformTypeName } from 'api/models/Platform.type'
import { platformAPI } from 'api/platformAPI'
import { forwardRef } from 'react'

export const PlatformSelect = forwardRef<HTMLDivElement, any>(
  function PlatformSelect(
    {
      value,
      onChange,
      ...props
    }: {
      value: string
      onChange: (code: string) => void
      props: any
    },
    ref,
  ) {
    const popper = (props: any) => {
      return <Popper {...props} placement="bottom-start" />
    }
    const { data } = useQuery({
      enabled: true,
      queryKey: ['getPlatforms'],
      queryFn: async () => platformAPI.getPlatforms(),
    })
    const options = data?.value ?? []
    const selectedPlatform =
      options.find((platform: any) => platform.id === value) ?? null

    return data ? (
      <Autocomplete
        ref={ref}
        id="platformId"
        disableClearable
        sx={{ width: 500 }}
        onChange={(_e, option: any | null) => {
          console.log(option)
          onChange(option ? option.id : '')
        }}
        size={props.size}
        PopperComponent={popper}
        value={selectedPlatform}
        options={options}
        autoHighlight
        getOptionLabel={(option: any) =>
          option
            ? `${option.name} - ${
                Object.entries(PlatformTypeName).filter(
                  (p) => p[0] === option.platformTypeName,
                )[0][1]
              }`
            : ''
        }
        renderOption={(props, option) => {
          return (
            <Box
              key={option.id}
              component="li"
              sx={{
                display: 'flex',
                alignItems: 'flex-start !important',
                flexDirection: 'column',
              }}
              {...props}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                  gap: '4px',
                }}
              >
                <Typography noWrap>{`${option.name} - ${
                  Object.entries(PlatformTypeName).filter(
                    (p) => p[0] === option.platformTypeName,
                  )[0][1]
                }`}</Typography>
              </Box>
            </Box>
          )
        }}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              size="small"
              label={'Choose a platform'}
              inputProps={{
                ...params.inputProps,
                autoComplete: 'off',
              }}
              required={props.required}
              error={props.error}
              helperText={props.helperText}
            />
          )
        }}
      />
    ) : (
      <></>
    )
  },
) as (props: any & { ref?: React.Ref<HTMLDivElement> }) => JSX.Element
